// generated by do-stack-dvwebapp-bump
export default {
	version: "1.3.0",
	date: "2022-10-27T20:24:26+02:00"
}
